import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { MuiThemeProvider } from 'material-ui/styles'

import { defaultTheme } from './themes/ideal'
import store from './redux/store'
import history from './history'
import App from './App'
import './index.css'

ReactDOM.render(
	<Provider store={store}>
		<Router history={history} component={App}>
			<MuiThemeProvider theme={defaultTheme}>
				<App />
			</MuiThemeProvider>
		</Router>
	</Provider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js